<script setup lang="ts">
import Sliderup from '@components/Sliderup.vue';
import IconLogo from '@icons/ph_logo.svg';
import Icon from '@components/Icon.vue';
import { URL_HOME, URL_LOGOUT } from '@tools/routes/routes';
import { type Component, computed } from 'vue';
import { AccountProfile } from '@enums/accountProfile.ts';
import { storeToRefs } from 'pinia';
import { useUserProfile } from '@stores/useUserProfile.ts';
import MobilePlusUnqualifiedMenu from '@layout/nav-v2/mobile/components/menus/MobilePlusUnqualifiedMenu.vue';
import MobilePlusSellerMenu from '@layout/nav-v2/mobile/components/menus/MobilePlusSellerMenu.vue';
import MobilePlusBuyerMenu from '@layout/nav-v2/mobile/components/menus/MobilePlusBuyerMenu.vue';
import MenuList from '@layout/nav-v2/mobile/components/MenuList.vue';
import ButtonLink from '@components/ButtonLink.vue';
import { trans } from '@elements/translation.ts';
import MenuAccountManagerContact from '@layout/nav-v2/MenuAccountManagerContact.vue';
import MobileHelpMenuDropdown from '@layout/nav-v2/mobile/components/menus/MobileHelpMenuDropdown.vue';

defineProps<{ isOpen: boolean }>();

const { userProfile, currentProfile, user } = storeToRefs(useUserProfile());

const menu = computed<Component>(() => {
  if (userProfile.value === AccountProfile.UNQUALIFIED) {
    return MobilePlusUnqualifiedMenu;
  }

  if (userProfile.value === AccountProfile.BOTH) {
    return currentProfile.value === AccountProfile.SELLER ? MobilePlusSellerMenu : MobilePlusBuyerMenu;
  }

  if (userProfile.value === AccountProfile.SELLER) {
    return MobilePlusSellerMenu;
  }

  return MobilePlusBuyerMenu;
});
</script>

<template>
  <Sliderup :is-opened="isOpen">
    <template #header>
      <a :href="URL_HOME">
        <Icon
          :svg="IconLogo"
          width="64"
          height="34"
        />
      </a>
    </template>

    <template #body>
      <div
        :class="[
          'mt-6',
          'px-4 pt-0 pb-20',
          'overflow-scroll',
        ]"
      >
        <MenuList class="flex flex-col space-y-2">
          <component :is="menu" />
        </MenuList>

        <MenuAccountManagerContact
          class="mt-4"
          :account-manager="user!.account_manager"
        />

        <MobileHelpMenuDropdown class="mt-4" />

        <ButtonLink
          :href="URL_LOGOUT"
          class="mt-6"
        >
          {{ trans('global.disconnect') }}
        </ButtonLink>
      </div>
    </template>
  </Sliderup>
</template>
